var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedDetailWarp"},[_c('div',{staticClass:"feedback-wrap"},[_c('img',{staticClass:"sucessIcon",attrs:{"src":_vm.img}}),_c('p',[_vm._v(" 提交成功")]),_c('div',[_vm._v("感谢您的反馈")]),_c('van-button',{on:{"click":function($event){return _vm.sureBtnClick()}}},[_vm._v("完成")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }